import React from 'react'

const ThemeContext = React.createContext({
  isDark: true,
  toggleTheme: () => {},
})

export default ThemeContext
